export type MembershipMetricGranularity = "week" | "month";

export interface MembershipMetricsBucket {
  // Bucket start as a YYYY-MM-DD string (Monday for weeks, the 1st for months).
  periodStart: string;
  // Members who started a membership in the bucket.
  newMembers: number;
  // All departures in the bucket (valid_to expiry + cancellation), so closing = opening + new - lost.
  lostMembers: number;
  netGrowth: number;
  // Point-in-time active-member headcount at the bucket boundaries.
  openingTotal: number;
  closingTotal: number;
}

export interface MembershipBreakdownItem {
  name: string;
  count: number;
}

// The late-rollover window offered on the Retention Reporting screen, in days. A renewal recorded
// within this many days of a member's previous expiry counts as continuous membership rather than a
// leaver plus a re-join — see LATE_ROLLOVER_OPTIONS in RetentionReporting.tsx.
export const DEFAULT_RENEWAL_GRACE_DAYS = 3;

export interface MembershipMetrics {
  from: string;
  to: string;
  granularity: MembershipMetricGranularity;
  // The late-rollover window (in days) the API actually applied, after clamping. null when the
  // response didn't report one (an API build that predates the parameter) — the screen must not
  // claim a window it cannot evidence.
  renewalGraceDays: number | null;
  buckets: MembershipMetricsBucket[];
  totalNewMembers: number;
  totalLostMembers: number;
  netGrowth: number;
  leadsInPeriod: number;
  conversionsInPeriod: number;
  leadToMemberConversionRate: number;
  // Active members as of the range end — anchors the running total / trend.
  totalActiveMembers: number;
  // Acquisition breakdown, keyed by the HowTheyHeard option CODE (e.g. "WalkingBy"). Render through the
  // client's configured signup.howTheyHeard labels — the codes are storage identifiers, not display text.
  howTheyHeard: MembershipBreakdownItem[];
  cancellationReasons: MembershipBreakdownItem[];
  membershipTypes: MembershipBreakdownItem[];
}
